import { CompanyContext } from "contexts/CompanyContext";
import React, { useContext, useEffect, useRef, useState } from "react";
import { BiMessageRounded } from 'react-icons/bi';
import { AiOutlineRetweet, AiOutlineHeart } from 'react-icons/ai';
import { IoStatsChartOutline } from 'react-icons/io5';
import { FiShare } from 'react-icons/fi';
import { HiDotsHorizontal, HiOutlineDotsHorizontal } from "react-icons/hi";
import { BsBookmark, BsChat, BsHeart, BsSend } from "react-icons/bs";
import { TbMessageCircle } from "react-icons/tb";
import { formatNumber } from "utils/formatNumber";
import { Carousel } from "react-responsive-carousel";
import MediaPreview from "./components/MediaPreview";
import AddAssetButton from "./components/AddAssetButton";
import { Dropdown } from "components/ui";
import usePostGenerator from "utils/hooks/usePostGenerator";
import { HiOutlinePlusCircle, HiOutlineTrash } from "react-icons/hi2";

const FacebookStoryPreview = (props) => {
    
    const {
        user_name,
        user_image,
        text,
        media,
        like_count,
        className,
        imgClassName,
        muted,
        title,
        preferences,
        link,

        assets,
        postIndex,
        isEditable,
        onAssetDelete,
        onAssetEdit,
        onAssetNew,
        onTextEdit, 
        onTitleEdit, 
        onLinkEdit, 
        onCreateNetworkPost,
        onDeleteIndexPost,
        onPreferencesEdit,
        allPosts = [],
        isSimpleView // Add this line
    } = props;

    let posts = [props];
    if ('0' in props) {
        posts = [];
        Object.keys(props).forEach((key) => {
            if (!isNaN(key)) {
                posts.push(props[key]);
            }
        });
    }

    const { generateEmptyPost } = usePostGenerator();
    const [ currentStory, setCurrentStory ] = useState(0);
    const [ timeLeft, setTimeLeft ] = useState(0);
    const [ timeTo, setTimeTo ] = useState(0);
    const dummyRefForDoubleStepStory = useRef(false);
    const videoRef = useRef();
    const carouselRef = useRef();
    const storyDuration = 5000; 

    const network = "facebook";
    const { company, companySocials } = useContext(CompanyContext);
    const integration = companySocials?.filter(e => e.type == network)?.[0];

    const handleOnNewStory = () => {
        let newPost = generateEmptyPost(network, "STORY");
        onCreateNetworkPost({...newPost?.posts?.[0]});
    }

    useEffect(() => {
        if (carouselRef.current) {
            carouselRef.current?.moveTo(posts?.length - 1);
        }
    }, [posts?.length]);

    useEffect(() => {
        setCurrentStory(carouselRef.current?.state?.selectedItem)
    }, [carouselRef.current?.state?.selectedItem])

    if (posts?.[0]?.preferences?.media_product_type != "STORY") return <></>;

    return (
        <div className={`cursor-pointer instagram overflow-hidden relative -mb-2 ${className}`}>
            <Carousel ref={carouselRef} showThumbs={posts?.filter(p => !!p?.assets?.length)?.length ? true : false} infiniteLoop={true} autoPlay={false} className="relative w-full h-full">
                {posts?.map((post, key) => {
                    const {
                        postIndex,
                        assets
                    } = post;
                    return (
                        <div className="relative"> 
                            <MediaPreview 
                                asset={assets?.[0]} 
                                parentClassName="!block bg-gray-900 aspect-[9/16]"
                                className={`object-contain !pointer-events-auto w-full h-full`} 
                                network={network}
                                isEditable={isEditable && !isSimpleView} // Update this line
                                onAssetDelete={() => onAssetDelete(postIndex, 0)}
                                onAssetEdit={(src) => onAssetEdit(postIndex, 0, src)}
                            />
                            {!assets?.length && !isSimpleView && 
                                <div className="absolute w-[90%] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[1000]">
                                    <AddAssetButton 
                                        network={network}
                                        onAssetNew={(asset) => onAssetNew(postIndex, asset)}
                                        onAssetDelete={(assetIndex) => onAssetDelete(postIndex, assetIndex)}
                                        post={post}
                                        allPosts={allPosts}
                                    />
                                </div>
                            }
                            <div className={`absolute left-0 top-0 w-full !h-[40%] p-3 flex flex-col gap-2 pointer-events-none bg-gradient-to-b from-gray-900/60 via-transparent to-transparent`}>
                                <div className="flex gap-1">
                                    {posts && posts?.length > 0 && posts?.map((_, index) => (
                                        <div className="flex-1 relative overflow-hidden">
                                            <div className={`border-t-2 border-gray-50 dark:border-gray-50 ${index >= currentStory && `opacity-[0.5]`}`}></div>
                                            {index == currentStory && <div className="absolute top-0 left-0 border-t-2 border-gray-50 dark:border-gray-50" style={{ width: `${((storyDuration - timeLeft) / storyDuration) * 100}%` }}></div>}
                                        </div>
                                    ))}
                                </div>
                                <div className="flex items-center gap-2 !pointer-events-auto">
                                    <Dropdown
                                        disabled={!isEditable || isSimpleView} // Update this line
                                        toggleClassName={(!isEditable || isSimpleView) && `!cursor-default`} // Update this line
                                        renderTitle={
                                            <span className="relative inline-block group rounded-full">
                                                <img src={user_image || integration?.image?.url || company?.image?.url || `/img/socials-rounded/${network}.svg`} className="shrink-0 rounded-full w-[44px] h-[44px]" />
                                                {isEditable && !isSimpleView &&  
                                                    <div className="transition-all cursor-pointer absolute left-0 top-0 rounded-full w-full h-full opacity-0 group-hover:opacity-100 bg-gray-900/40 flex items-center justify-center text-2xl text-white">
                                                        <HiDotsHorizontal />
                                                    </div>
                                                }
                                            </span>
                                        }
                                    >
                                        <Dropdown.Item onClick={() => handleOnNewStory()} className="flex items-center gap-2 py-2 px-4">
                                            <HiOutlinePlusCircle className='h-6 md:text-xl text-green-600' />
                                            <span>Create new story</span>
                                        </Dropdown.Item>
                                        {posts?.length > 1 && <Dropdown.Item onClick={() => onDeleteIndexPost(postIndex)} className="flex items-center gap-2 py-2 px-4">
                                            <HiOutlineTrash className='h-6 md:text-xl text-red-600' />
                                            <span>Delete post</span>
                                        </Dropdown.Item>}
                                    </Dropdown>
                                    <span className="!text-xs font-bold text-secondary-500 dark:text-secondary-500">{user_name || integration?.name || company?.name}</span>
                                    <span className="!text-xs text-tertiary-400 pl-1">6s</span>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </Carousel>
        </div>
    )
}

export default FacebookStoryPreview;